module.exports = __webpack_public_path__ + "static/logo-lg-c3c5967413c56ceab9a3f95c86e62f81.mp4";